<template>
  <div>
    <Dialog
      :key="formKey"
      :visible.sync="customerDialog1"
      :style="{ width: '700px', overflowY: 'auto' }"
      header="Customer Details"
      :modal="true"
      class="p-fluid"
    >
      <template #header>
        <h5>Customer Details</h5>

        <div v-if="customerToEdit && customerToEdit.customerId">
          <strong v-if="customerToEdit.status">{{
            customerToEdit.status
          }}</strong>
          <strong v-else-if="customerToEdit.active" style="color: green;"
            >Active</strong
          >
          <strong v-else style="color: red;">Inactive</strong>
        </div>
      </template>

      <div
        v-if="
          customerToEdit &&
            customerToEdit.customerId &&
            customerToEdit.requireApproval &&
            !(
              $store.getters['auth/getMyProfile'] &&
              $store.getters['auth/getMyProfile'].role &&
              $store.getters['auth/getMyProfile'].role.roleName &&
              $store.getters['auth/getMyProfile'].role.roleName === 'Admin'
            )
        "
      >
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="custName">Customer Name *</label>
            <InputText
              id="custName"
              v-model.trim="customer.custName"
              required="true"
              :class="{ 'p-invalid': submitted && !customer.custName }"
              @blur="checkForDuplicate"
              :disabled="isDisabled('custName')"
            />
            <small class="p-invalid" v-if="submitted && !customer.custName"
              >Customer Name is required.</small
            >
          </div>
          <div class="p-field p-col">
            <label for="address1">House</label>
            <InputText
              id="address1"
              v-model.trim="customer.address1"
              :class="{ 'p-invalid': submitted && !customer.address1 }"
              @blur="checkForDuplicate"
              :disabled="isDisabled('address1')"
            />
            <small class="p-invalid" v-if="submitted && !customer.address1"
              >Address1 is required.</small
            >
          </div>
        </div>
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="address2">Street</label>
            <InputText
              id="address2"
              v-model.trim="customer.address2"
              :class="{ 'p-invalid': submitted && !customer.address2 }"
              required="false"
              @blur="checkForDuplicate"
              :disabled="isDisabled('address2')"
            />
            <small class="p-invalid" v-if="submitted && !customer.address2"
              >Address2 is required.</small
            >
          </div>
          <div class="p-field p-col">
            <label for="address3">Sub Area</label>
            <InputText
              id="address3"
              v-model.trim="customer.address3"
              :class="{ 'p-invalid': submitted && !customer.address3 }"
              required="false"
              autofocus
              @blur="checkForDuplicate"
              :disabled="isDisabled('address3')"
            />
            <small class="p-invalid" v-if="submitted && !customer.address3"
              >Address3 is required.</small
            >
          </div>
        </div>
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="address4">City/Town</label>
            <CustomDropDown
              :allOptions="citiesTowns"
              :disabled="isDisabled('address4')"
              optionLabel="cityTownName"
              dataKey="id"
              :forceSelection="true"
              :showDropDownOnStart="true"
              :currentValue="cityTown"
              placeholder="Select City/Town"
              style="width: 100%"
              @selected="setCityTownSelection"
              :inputClass="{ 'p-invalid': submitted && !customer.cityTown }"
            />
            <small class="p-invalid" v-if="submitted && !customer.cityTown"
              >City/Town is required.</small
            >
          </div>
          <div class="p-field p-col">
            <label for="postCode">Post Code</label>
            <InputText
              id="postCode"
              v-model.trim="postCode"
              required="false"
              :class="{ 'p-invalid': submitted && !customer.postCode }"
              autofocus
              @blur="checkForDuplicate"
              :disabled="isDisabled('postCode')"
            />
            <small class="p-invalid" v-if="submitted && !customer.postCode"
              >Post Code is required.</small
            >
          </div>
        </div>

        <div class="p-formgrid p-grid">
          <div class="p-field p-col" v-if="duplicateChecking">
            <div class="errorMsg" style="background-color: dodgerblue;">
              <span class="errorSpan">
                Checking for duplicate customers...
              </span>
            </div>
          </div>
          <div
            class="p-field p-col"
            v-if="!duplicateChecking && duplicates.length"
          >
            <div class="errorMsg">
              <span class="errorSpan pr-5">
                Possible duplicate customers: {{ duplicates.length }}
              </span>
              <span
                class="errorSpan errorPointer pr-3"
                @click="displayDuplicateMessage = true"
              >
                View duplicates
              </span>
              <span
                class="errorSpan errorPointer"
                @click="checkForDuplicate()"
                v-if="
                  lastEnteredName !== customer.custName ||
                    lastEnteredAddress1 !== customer.address1 ||
                    lastEnteredAddress2 !== customer.address2 ||
                    lastEnteredAddress3 !== customer.address3 ||
                    lastEnteredCityTown !==
                      (customer.cityTown && customer.cityTown.id) ||
                    lastEnteredPostCode !== customer.postCode
                "
              >
                Check again
              </span>
            </div>
          </div>
        </div>

        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="region">Region</label>
            <InputText
              id="region"
              v-model.trim="region.regionName"
              :disabled="true"
              required="false"
              autofocus
            />
          </div>
          <div class="p-field p-col">
            <label for="branchName">Branch</label>
            <InputText
              id="branch"
              v-model.trim="branch.branchName"
              :disabled="true"
              required="false"
              autofocus
            />
          </div>
        </div>
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="salesExec">Sales Exec</label>
            <InputText
              id="salesExec"
              v-model.trim="salesExec.salesExecName"
              :disabled="isDisabled('salesExec')"
              required="false"
              autofocus
            />
          </div>
          <div class="p-field p-col">
            <label for="customerType">Customer Type</label>
            <Dropdown
              id="customerType"
              v-model="customerType"
              :options="customertypes"
              optionLabel="typeName"
              placeholder="Select Customer Type"
              :class="{ 'p-invalid': submitted && !customer.customerType }"
              :showClear="true"
              :disabled="isDisabled('customerType')"
            />
            <small class="p-invalid" v-if="submitted && !customer.customerType"
              >Customer Type is required.</small
            >
          </div>
        </div>
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="phoneNo">Phone No</label>
            <InputText
              id="phoneNo"
              v-model.trim="customer.phoneNo"
              :class="{ 'p-invalid': submitted && !customer.phoneNo }"
              required="false"
              :disabled="isDisabled('phoneNo')"
            />
            <small class="p-invalid" v-if="submitted && !customer.phoneNo"
              >Phone number is required.</small
            >
          </div>
          <div class="p-field p-col">
            <label for="email">Email</label>
            <InputText
              id="email"
              v-model.trim="customer.mainEmail"
              required="false"
              autofocus
              :disabled="isDisabled('email')"
            />
          </div>
        </div>
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="mainNotes">Notes</label>
            <InputText
              id="mainNotes"
              v-model.trim="customer.mainNotes"
              required="false"
              :disabled="isDisabled('mainNotes')"
            />
          </div>
        </div>
      </div>
      <div v-else>
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="Code">Account No *</label>
            <InputText
              :key="updateAccountInput"
              id="custCode"
              required="true"
              :autofocus="!(customerToEdit && customerToEdit.custCode)"
              :class="{ 'p-invalid': duplicateCustCode }"
              style="text-transform: uppercase;"
              @input="checkCustCode"
              @blur="revertCustCode"
              v-model="customer.custCode"
              :disabled="isDisabled('custCode')"
            />
            <small class="p-invalid" v-if="duplicateCustCode"
              >The Account No is already used</small
            >
            <small class="p-invalid" v-if="custCodeUpdateError"
              >Please change or select a different Account Code from the "View
              MBP Branch Accounts" Page.</small
            >
          </div>
          <div class="p-field p-col">
            <label for="custName">Customer Name *</label>
            <InputText
              autofocus
              @blur="checkForDuplicate"
              id="custName"
              v-model.trim="customer.custName"
              required="true"
              :class="{ 'p-invalid': submitted && !customer.custName }"
              style="text-transform: uppercase;"
              :disabled="isDisabled('custName')"
            />
            <small class="p-invalid" v-if="submitted && !customer.custName"
              >Customer Name is required.</small
            >
          </div>
        </div>
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="parentFlag">Parent Customer?</label>
            <SelectButton
              v-model="parentFlag"
              :options="options"
              optionLabel="label"
              optionValue="value"
              :disabled="isDisabled('parentFlag')"
            />
          </div>
          <div class="p-field p-col">
            <label for="parentCustomer">Parent Customer</label>
            <CustomDropDown
              :allOptions="parentCustomers"
              :disabled="isDisabled('parentCustomer')"
              optionLabel="parentCompany"
              dataKey="customerId"
              :forceSelection="true"
              :showDropDownOnStart="true"
              :currentValue="parentCustomer"
              placeholder="Select Parent Customer"
              style="width: 100%"
              :useCustomID="true"
              :index="1"
              @selected="setParentSelection"
            />
          </div>
        </div>
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="address1">House</label>
            <InputText
              @blur="checkForDuplicate"
              id="address1"
              v-model.trim="customer.address1"
              :class="{ 'p-invalid': submitted && !customer.address1 }"
              style="text-transform: uppercase;"
              :disabled="isDisabled('address1')"
            />
            <small class="p-invalid" v-if="submitted && !customer.address1"
              >House is required.</small
            >
          </div>
          <div class="p-field p-col">
            <label for="address2">Street</label>
            <InputText
              @blur="checkForDuplicate"
              id="address2"
              v-model.trim="customer.address2"
              :class="{ 'p-invalid': submitted && !customer.address2 }"
              required="false"
              style="text-transform: uppercase;"
              :disabled="isDisabled('address2')"
            />
            <small class="p-invalid" v-if="submitted && !customer.address2"
              >Street is required.</small
            >
          </div>
        </div>
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="address3">Sub Area</label>
            <InputText
              @blur="checkForDuplicate"
              id="address3"
              v-model.trim="customer.address3"
              :class="{ 'p-invalid': submitted && !customer.address3 }"
              required="false"
              autofocus
              style="text-transform: uppercase;"
              :disabled="isDisabled('address3')"
            />
            <small class="p-invalid" v-if="submitted && !customer.address3"
              >Sub Area is required.</small
            >
          </div>
          <div class="p-field p-col">
            <label for="address4">City/Town</label>
            <CustomDropDown
              :key="reloadCustomDropdown"
              :allOptions="citiesTowns"
              :disabled="isDisabled('address4')"
              optionLabel="cityTownName"
              dataKey="id"
              :forceSelection="true"
              :showDropDownOnStart="true"
              :currentValue="cityTown"
              placeholder="Select City/Town"
              style="width: 100%"
              :useUpperCase="true"
              :useCustomID="true"
              :index="2"
              :inputClass="{
                'p-invalid': submitted && !(cityTown && cityTown.id)
              }"
              @selected="setCityTownSelection"
            />
            <small
              class="p-invalid"
              v-if="submitted && !(cityTown && cityTown.id)"
              >City/Town is required.</small
            >
          </div>
        </div>
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="postCode">Post Code</label>
            <InputText
              @blur="checkForDuplicate"
              id="postCode"
              v-model.trim="postCode"
              required="false"
              :class="{ 'p-invalid': submitted && !customer.postCode }"
              autofocus
              style="text-transform: uppercase;"
              :disabled="isDisabled('postCode')"
            />
            <small class="p-invalid" v-if="submitted && !customer.postCode"
              >Post Code is required.</small
            >
          </div>
          <div class="p-field p-col">
            <label for="region">Region</label>
            <Dropdown
              id="region"
              v-model="region"
              :options="regions"
              optionLabel="regionName"
              placeholder="Select Region"
              :showClear="true"
              :key="customerRegionKey"
              :class="{
                'p-invalid': submitted && !(region && region.regionName)
              }"
              :disabled="isDisabled('region')"
            />
            <small
              class="p-invalid"
              v-if="submitted && !(region && region.regionName)"
              >Region is required.</small
            >
          </div>
        </div>

        <div class="p-formgrid p-grid">
          <div class="p-field p-col" v-if="duplicateChecking">
            <div class="errorMsg" style="background-color: dodgerblue;">
              <span class="errorSpan">
                Checking for duplicate customers...
              </span>
            </div>
          </div>
          <div
            class="p-field p-col"
            v-if="!duplicateChecking && duplicates.length"
          >
            <div class="errorMsg">
              <span class="errorSpan pr-5">
                Possible duplicate customers: {{ duplicates.length }}
              </span>
              <span
                class="errorSpan errorPointer pr-3"
                @click="displayDuplicateMessage = true"
              >
                View duplicates
              </span>
              <span
                class="errorSpan errorPointer"
                @click="checkForDuplicate()"
                v-if="
                  lastEnteredName !== customer.custName ||
                    lastEnteredAddress1 !== customer.address1 ||
                    lastEnteredAddress2 !== customer.address2 ||
                    lastEnteredAddress3 !== customer.address3 ||
                    lastEnteredCityTown !==
                      (customer.cityTown && customer.cityTown.id) ||
                    lastEnteredPostCode !== customer.postCode
                "
              >
                Check again
              </span>
            </div>
          </div>
        </div>

        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="salesExec">Branch</label>
            <Dropdown
              v-model="branch"
              :options="branches"
              optionLabel="branchName"
              placeholder="Select Branch"
              dataKey="id"
              :showClear="
                customerToEdit &&
                customerToEdit.customerId &&
                !customerToEdit.requireApproval
                  ? false
                  : true
              "
              :class="{ 'p-invalid': submitted && !(branch && branch.id) }"
              :disabled="
                customerToEdit &&
                customerToEdit.customerId &&
                !customerToEdit.requireApproval
                  ? true
                  : false
              "
            />
            <small class="p-invalid" v-if="submitted && !(branch && branch.id)"
              >Branch is required.</small
            >
          </div>
          <div class="p-field p-col">
            <label for="salesExec">Sales Exec</label>
            <Dropdown
              id="salesExec"
              v-model="salesExec"
              :options="salesExecs"
              optionLabel="salesExecName"
              placeholder="Select Sales Executive"
              :showClear="true"
              :key="customerSalesExecKey"
              :class="{
                'p-invalid': submitted && !(salesExec && salesExec.id)
              }"
              :disabled="isDisabled('salesExec')"
            />
            <small
              class="p-invalid"
              v-if="submitted && !(salesExec && salesExec.id)"
              >SalesExec is required.</small
            >
          </div>
        </div>
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="customerType">Customer Type</label>
            <Dropdown
              id="customerType"
              v-model="customerType"
              :options="customertypes"
              optionLabel="typeName"
              placeholder="Select Customer Type"
              :class="{
                'p-invalid': submitted && !(customerType && customerType.id)
              }"
              :showClear="true"
              :disabled="isDisabled('customerType')"
            />
            <small
              class="p-invalid"
              v-if="submitted && !(customerType && customerType.id)"
              >Customer Type is required.</small
            >
          </div>
          <div class="p-field p-col">
            <label for="keyContact">Key Contact</label>
            <Dropdown
              id="keyContact"
              v-model="keyContact"
              :options="contacts"
              optionLabel="contactName"
              placeholder="Select Key Contact"
              required="false"
              :showClear="true"
              :disabled="isDisabled('keyContact')"
              :class="{
                'p-invalid':
                  submitted &&
                  customerToEdit &&
                  customerToEdit.customerId &&
                  contacts &&
                  contacts.length &&
                  !customer.keyContact
              }"
            />
            <small
              class="p-invalid"
              v-if="
                submitted &&
                  customerToEdit &&
                  customerToEdit.customerId &&
                  contacts &&
                  contacts.length &&
                  !customer.keyContact
              "
              >Key Contact is required.</small
            >
          </div>
        </div>
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="phoneNo">Phone No</label>
            <InputText
              id="phoneNo"
              v-model.trim="customer.phoneNo"
              :class="{ 'p-invalid': submitted && !customer.phoneNo }"
              required="false"
              :disabled="isDisabled('phoneNo')"
            />
            <small class="p-invalid" v-if="submitted && !customer.phoneNo"
              >Phone number is required.</small
            >
          </div>
          <div class="p-field p-col">
            <label for="mobile">Mobile</label>
            <InputText
              id="mobile"
              v-model.trim="customer.mobile"
              required="false"
              autofocus
              :disabled="isDisabled('mobile')"
            />
          </div>
        </div>
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="faxNo">Fax No</label>
            <InputText
              id="faxNo"
              v-model.trim="customer.faxNo"
              required="false"
              autofocus
              :disabled="isDisabled('faxNo')"
            />
          </div>
          <div class="p-field p-col">
            <label for="mainEmail">Main Email</label>
            <InputText
              id="mainEmail"
              v-model.trim="customer.mainEmail"
              required="false"
              autofocus
              :disabled="isDisabled('mainEmail')"
            />
          </div>
        </div>
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="website">Website</label>
            <InputText
              id="website"
              v-model.trim="customer.website"
              required="false"
              :disabled="isDisabled('website')"
            />
          </div>
          <div class="p-field p-col">
            <label for="tags">Tags</label>
            <MultiSelect
              v-model="tag"
              :options="tags"
              dataKey="id"
              optionLabel="tag"
              placeholder="Select tag/s"
              display="chip"
              :disabled="isDisabled('tag')"
            />
          </div>
        </div>
        <!-- <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="vatNo">Vat No</label>
            <InputText
              id="vatNo"
              v-model.trim="customer.vatNo"
              required="false"
            />
          </div>
          <div class="p-field p-col">
            <label for="chargeVAT">Charge VAT?</label>
            <SelectButton
              v-model="customer.chargeVAT"
              :options="options"
              optionLabel="label"
              optionValue="value"
            />
          </div>
        </div> -->
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="showMsg">Message</label>
            <InputText
              id="showMsg"
              v-model.trim="customer.showMsg"
              required="false"
              :disabled="isDisabled('showMsg')"
            />
          </div>
        </div>
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="rebatePercent">Rebate %</label>
            <input
              id="rebatePercent"
              type="number"
              step="0.01"
              min="0"
              max="100"
              inputmode="decimal"
              class="p-inputtext p-component"
              style="width: 100%;"
              :value="customer.rebatePercent"
              @input="customer.rebatePercent = $event.target.value === '' ? null : parseFloat($event.target.value)"
              :disabled="isDisabled('rebatePercent')"
            />
          </div>
          <div class="p-field p-col">
            <label for="msgDisplayMode">Show as popup window?</label>
            <Dropdown
              id="msgDisplayMode"
              v-model="customer.msgDisplayMode"
              :options="rebateDisplayModeOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Use default"
              :disabled="isDisabled('msgDisplayMode')"
            />
            <small style="display:block; color:#6c757d;">
              The rebate &amp; customer message always shows as a banner. Choose whether it also pops up as a window, or use the global default.
            </small>
          </div>
        </div>
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="rebateMessage">Rebate Message</label>
            <InputText
              id="rebateMessage"
              v-model.trim="customer.rebateMessage"
              required="false"
              :disabled="isDisabled('rebateMessage')"
            />
            <small style="display:block; color:#6c757d;">
              Optional. Overrides the standard rebate notice for this customer. Leave blank to use the global default message.
            </small>
          </div>
        </div>
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="mainNotes">Notes</label>
            <InputText
              id="mainNotes"
              v-model.trim="customer.mainNotes"
              required="false"
              :disabled="isDisabled('mainNotes')"
            />
          </div>
        </div>
      </div>

      <template #footer>
        <div v-if="!disabledArr.includes('buttons')">
          <ProgressSpinner
            v-if="
              sendingRequest &&
                customerToEdit &&
                customerToEdit.customerId &&
                customerToEdit.requireApproval &&
                $store.getters['auth/getMyProfile'] &&
                $store.getters['auth/getMyProfile'].role &&
                $store.getters['auth/getMyProfile'].role.roleName &&
                $store.getters['auth/getMyProfile'].role.roleName === 'Admin'
            "
            style="width:25px; height:25px; width: 100px; float: left;"
            strokeWidth="5"
            fill="#EEEEEE"
            animationDuration=".5s"
          />
          <Button
            v-else-if="
              customerToEdit &&
                customerToEdit.customerId &&
                customerToEdit.requireApproval &&
                $store.getters['auth/getMyProfile'] &&
                $store.getters['auth/getMyProfile'].role &&
                $store.getters['auth/getMyProfile'].role.roleName &&
                $store.getters['auth/getMyProfile'].role.roleName === 'Admin'
            "
            label="Approve & save"
            icon="pi pi-check"
            class="p-button-success"
            style="width: 170px; float: left;"
            @click="saveAndApproveWarning = true"
          />
          <ProgressSpinner
            v-if="
              sendingRequest &&
                customerToEdit &&
                customerToEdit.customerId &&
                customerToEdit.requireApproval &&
                $store.getters['auth/getMyProfile'] &&
                $store.getters['auth/getMyProfile'].role &&
                $store.getters['auth/getMyProfile'].role.roleName &&
                $store.getters['auth/getMyProfile'].role.roleName === 'Admin'
            "
            style="width:25px; height:25px; width: 100px; float: left;"
            strokeWidth="5"
            fill="#EEEEEE"
            animationDuration=".5s"
          />
          <Button
            v-else-if="
              customerToEdit &&
                customerToEdit.customerId &&
                customerToEdit.requireApproval &&
                $store.getters['auth/getMyProfile'] &&
                $store.getters['auth/getMyProfile'].role &&
                $store.getters['auth/getMyProfile'].role.roleName &&
                $store.getters['auth/getMyProfile'].role.roleName === 'Admin'
            "
            label="Assign Customer"
            icon="pi pi-check"
            class="p-button-success"
            style="width: 170px; float: left;"
            @click="assignCustomer()"
          />
          <Button
            label="Cancel"
            icon="pi pi-times"
            class="p-button-danger"
            style="width: 100px;"
            @click="hideDialog"
          />
          <ProgressSpinner
            v-if="sendingRequest"
            style="width:25px; height:25px; width: 100px;"
            strokeWidth="5"
            fill="#EEEEEE"
            animationDuration=".5s"
          />
          <Button
            v-else
            label="Save"
            icon="pi pi-check"
            class="p-button-success"
            style="width: 100px;"
            @click="saveCustomer(true)"
          />
        </div>
      </template>
    </Dialog>

    <Dialog
      header="Warning"
      :visible.sync="duplicateAccountNoWarning"
      :style="{ width: '700px' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-info-circle p-mr-3" style="font-size: 2rem" />
        <span
          v-if="
            duplicateCustCode &&
              duplicateCustCode[0] &&
              duplicateCustCode[0].mbpBranch &&
              duplicateCustCode[0].mbpBranch.branchName
          "
          >The Account No entered is already used for Branch:
          {{ duplicateCustCode[0].mbpBranch.branchName }}</span
        >
        <span v-else>The Account No entered is already used for a branch</span>
      </div>
      <template #footer>
        <Button
          label="Ok"
          icon="pi pi-check"
          @click="duplicateAccountNoWarning = false"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>

    <Dialog
      header="Warning"
      :visible.sync="saveAndApproveWarning"
      :style="{ width: '700px' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-info-circle p-mr-3" style="font-size: 2rem" />
        <span
          >All associated enquiries will also be updated based on the Customer
          info updated. Do you wish to continue?</span
        >
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          @click="saveAndApproveWarning = false"
          class="p-button-text"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          @click="(saveAndApproveWarning = false), saveCustomer(false)"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>

    <duplicateTable
      v-if="displayDuplicateMessage"
      :duplicateDialog="displayDuplicateMessage"
      :dataId="'customerId'"
      :name="'Customer'"
      :namePlural="'Customers'"
      :list="duplicates"
      :disabledArr="['buttons']"
      @close="displayDuplicateMessage = false"
    />
  </div>
</template>

<script>
import CustomerService from "@/service/CustomerService";
import TagsService from "@/service/TagsService";
import SettingService from "@/service/SettingService";

import duplicateTable from "./duplicateDialog";

import { customerRequest, customerLessDataRequest } from "../sendRequest";
import { parseTagNames, resolveTagNames } from "./customerTags";

export default {
  components: {
    duplicateTable
  },
  props: ["customerDialog", "customerToEdit", "disabledArr"],
  data: () => ({
    customerService: new CustomerService(),
    tagsService: new TagsService(),
    settingService: new SettingService(),
    formKey: 0,
    // rebatePercent/msgDisplayMode are pre-declared so Vue 2 tracks them reactively
    // (v-model on keys added later to a plain object would not be reactive).
    customer: { rebatePercent: null, msgDisplayMode: null, rebateMessage: null },
    submitted: false,
    parentCustomers: [],
    customertypes: [],
    salesExecs: [],
    contacts: [],
    regions: [],
    region: {},
    parentCustomer: {},
    customerType: {},
    salesExec: {},
    customerSalesExecKey1: 0,
    customerRegionKey1: 0,
    postCode: "",
    parentFlag: false,
    options: [
      { value: true, label: "yes" },
      { value: false, label: "no" }
    ],
    rebateDisplayModeOptions: [
      { label: "Use default", value: 1 },
      { label: "Yes — show as popup", value: 3 },
      { label: "No — banner only", value: 2 }
    ],
    tags: [],
    duplicateCustCode: null,
    duplicateAccountNoWarning: false,
    branches: [],
    branch: {},
    tag: [],
    // Tag names read off customers.tags, held until the tag options arrive. The customer
    // and the options load in parallel, so whichever lands second triggers the match.
    pendingTagNames: [],
    // Names that no longer match any tag (e.g. the tag was renamed). Kept so the save
    // path can refuse to send a partial list instead of wiping the customer's tags.
    unresolvedTagNames: [],
    sendingRequest: false,
    keyContact: {},
    citiesTowns: [],
    cityTown: {},
    reloadCustomDropdown1: 0,
    saveAndApproveWarning: false,

    duplicates: [],
    duplicateChecking: false,
    lastEnteredName: "",
    lastEnteredPostCode: "",
    lastEnteredAddress1: "",
    lastEnteredAddress2: "",
    lastEnteredAddress3: "",
    lastEnteredCityTown: "",
    displayDuplicateMessage: false,

    custCodeUpdateError: false,
    updateAccountInputKey: 0
  }),
  computed: {
    updateAccountInput: {
      set(val) {
        this.updateAccountInputKey++;
      },
      get() {
        return "updateAccountInput" + this.updateAccountInputKey.toString();
      }
    },
    reloadCustomDropdown: {
      set(val) {
        this.reloadCustomDropdown1++;
      },
      get() {
        return "reloadCustomDropdown" + this.reloadCustomDropdown1.toString();
      }
    },
    customerRegionKey: {
      set(val) {
        this.customerRegionKey1++;
      },
      get() {
        return "customerRegionKey" + this.customerRegionKey1.toString();
      }
    },
    customerSalesExecKey: {
      set(val) {
        this.customerSalesExecKey1++;
      },
      get() {
        return "customerSalesExecKey" + this.customerSalesExecKey1.toString();
      }
    },
    customerDialog1: {
      set(val) {
        if (!val) {
          this.hideDialog();
        }
      },
      get() {
        return this.customerDialog ? true : false;
      }
    }
  },
  created() {
    this.customerService
      .getParentCustomers()
      .then(data => (this.parentCustomers = data))
      .catch(e => {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting parent customers",
        //   life: 5000,
        // })
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "parentcustomernames"'
        });
      });

    this.customerService
      .getAllActiveCustomerTypes()
      .then(data => (this.customertypes = data))
      .catch(e => {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting customer types",
        //   life: 5000,
        // })
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "activeCustomerTypes"'
        });
      });

    this.customerService
      .getAllActiveRegions()
      .then(data => (this.regions = data))
      .catch(e => {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting regions",
        //   life: 5000,
        // })
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "activeRegions"'
        });
      });

    this.customerService
      .getAllActiveSalesExecs()
      .then(data => (this.salesExecs = data))
      .catch(e => {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting sales exec",
        //   life: 5000,
        // })
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "activeSalesExecs"'
        });
      });

    this.settingService
      .getAllActiveBranches()
      .then(data => {
        this.branches = data;
      })
      .catch(err => {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting branches",
        //   life: 5000,
        // })
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "activeMbpBranches"'
        });
      });

    this.customerService
      .getAllActiveCitiesTowns()
      .then(data => (this.citiesTowns = data))
      .catch(error => {
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "citiesTowns"'
        });
      });

    this.setupCustomerToEdit();
    this.getTagsOfType();
  },
  watch: {
    keyContact(val) {
      this.customer.keyContact = val;
    },
    tag(val) {
      this.customer.tags = val;
    },
    cityTown(val) {
      if (val && val.id) {
        this.customer.cityTown = { ...val };
        this.reloadCustomDropdown = this.reloadCustomDropdown1 + 1;
      } else {
        this.customer.cityTown = null;
      }
    },
    region(val) {
      if (val && val.id) {
        this.customer.region = { ...val };
      } else {
        this.customer.region = null;
      }
    },
    branch(val) {
      //
      if (val && val.id) {
        this.customer.mbpBranch = { ...val };
      } else {
        this.customer.mbpBranch = null;
      }
    },
    salesExec(val) {
      if (val && val.id) {
        this.customer.salesExec = { ...val };
      } else {
        this.customer.salesExec = null;
      }
      // val && val.id ? this.customer.salesExec = val : this.customer.salesExec = null
    },
    customerType(val) {
      val && val.id
        ? (this.customer.customerType = val)
        : (this.customer.customerType = null);
    },
    parentCustomer(val) {
      val && val.customerId
        ? (this.customer.parentCustomer = val)
        : (this.customer.parentCustomer = null);
    },
    parentFlag(val) {
      val
        ? (this.customer.parentFlag = val)
        : (this.customer.parentFlag = null);
    },
    postCode(val) {
      this.customer.postCode = val;

      if (!(this.customerToEdit && this.customerToEdit.customerId)) {
        this.customerService
          .getCustomerRegion(val)
          .then(res => {
            if (res[0] && res[0].id) {
              this.branch = res[0].mbpBranch;
              this.region = res[0];
              this.customerRegionKey++;
              this.salesExec = res[0].salesExec;
              this.customerSalesExecKey++;
            } else {
              throw new Error("Nothing found");
            }
          })
          .catch(err => {
            this.region = {};
            this.customer.region = {};
            this.customerRegionKey++;
            this.salesExec = {};
            this.customer.salesExec = {};
            this.customerSalesExecKey++;
          });
      }
    },
    region(val) {
      this.customer.region = val;
      this.customer.salesExec = val.salesExec;
      this.customerSalesExecKey++;
    },
    customerDialog1(val) {
      if (val) {
        this.setupCustomerToEdit();
      }
      this.formKey++;
    }
  },
  methods: {
    isDisabled(field) {
      if (this.disabledArr.includes(field)) {
        return true;
      } else {
        return false;
      }
    },
    revertCustCode() {
      if (this.customerToEdit && this.customerToEdit.custCode) {
        this.custCodeUpdateError = false;
        this.customer.custCode = this.customerToEdit.custCode;
        this.updateAccountInput++;
      }
    },
    checkCustCode() {
      if (this.customerToEdit && this.customerToEdit.custCode) {
        this.custCodeUpdateError = true;
      }
    },
    checkForDuplicate() {
      if (
        this.customer &&
        this.customer.custName &&
          this.customer.address1 &&
          this.customer.address2 &&
          this.customer.address3 &&
          this.customer.cityTown &&
          this.customer.cityTown.id &&
          this.customer.postCode &&
        (this.lastEnteredName !== this.customer.custName ||
          this.lastEnteredAddress1 !== this.customer.address1 ||
          this.lastEnteredAddress2 !== this.customer.address2 ||
          this.lastEnteredAddress3 !== this.customer.address3 ||
          this.lastEnteredCityTown !== this.customer.cityTown.id ||
          this.lastEnteredPostCode !== this.customer.postCode)
      ) {
        //

        this.lastEnteredName = this.customer.custName;
        this.lastEnteredAddress1 = this.customer.address1;
        this.lastEnteredAddress2 = this.customer.address2;
        this.lastEnteredAddress3 = this.customer.address3;
        this.lastEnteredCityTown = this.customer.cityTown.id;
        this.lastEnteredPostCode = this.customer.postCode;

        this.duplicateChecking = true;
        this.customerService
          .getDupCustomers({
            custName: this.customer.custName,
            address1: this.customer.address1,
            address2: this.customer.address2,
            address3: this.customer.address3,
            cityTown: this.customer.cityTown.id,
            postCode: this.customer.postCode,
            address4: ""
          })
          .then(data => {
            this.duplicateChecking = false;
            //
          })
          .catch(error => {
            //
            this.duplicateChecking = false;
            this.duplicates = [];

            if (error && error.response && error.response.status === 409) {
              this.duplicates = error.response.data;
            } else {
              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: "Error while checking for duplicate enquiries.",
                life: 5000
              });
            }
          });
      }
    },
    getTagsOfType() {
      this.tagsService
        .getTagsOfType("CUSTOMER")
        .then(data => {
          this.tags = data;
          // The customer request and this one race each other. If the customer landed
          // first its tag names are still pending, so match them now that we have options.
          this.resolveSelectedTags();
        })
        .catch(err => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while geting tags for type CUSTOMER",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "tags/type"'
          });
        });
    },
    // Match the customer's stored tag names against the loaded tag options. Safe to call
    // more than once and from either side of the race - it no-ops until both have landed.
    resolveSelectedTags() {
      if (!this.pendingTagNames || !this.pendingTagNames.length) {
        this.tag = [];
        this.unresolvedTagNames = [];
        return;
      }

      const { selected, unresolved, optionsReady } = resolveTagNames(
        this.pendingTagNames,
        this.tags
      );

      // Options have not arrived yet; leave the selection alone and wait to be called again.
      if (!optionsReady) return;

      this.tag = selected;
      this.unresolvedTagNames = unresolved;

      if (unresolved.length && this.$toast) {
        // Do not fail silently: the customer holds a tag whose name has since changed, so
        // the save path will not send a partial list. Use a toast rather than the store's
        // error banner - that banner collapses everything into one generic "Some data was
        // not loaded" line, which hides the reason the Tags box looks empty.
        this.$toast.add({
          severity: "warn",
          summary: "Tag no longer exists",
          detail:
            'This customer is tagged "' +
            unresolved.join('", "') +
            '", which is not in the tag list any more (it may have been renamed). ' +
            "The Tags box below is therefore incomplete, so saving will leave this customer's tags exactly as they are.",
          life: 10000
        });
      }
    },
    setupEditCustomer(customer) {
      Object.keys(customer).forEach(key => {
        this.customer[key] = customer[key];

        if (key === "postCode") {
          this.postCode = customer[key];
        } else if (key === "tags" && typeof customer[key] === "string") {
          // Hold the names; resolveSelectedTags() matches them once the options exist.
          this.pendingTagNames = parseTagNames(customer[key]);
          this.resolveSelectedTags();
        } else if (key === "keyContact") {
          this.keyContact = customer[key];
        }

        if (customer[key] && customer[key].id) {
          if (key === "region") {
            this.region = { ...customer[key] };
          } else if (key === "customerType") {
            this.customerType = customer[key];
          } else if (key === "salesExec") {
            this.salesExec = customer[key];
          } else if (key === "mbpBranch") {
            this.branch = customer[key];
          } else if (key === "cityTown") {
            this.cityTown = customer[key];
          }
        } else if (customer[key] && customer[key].customerId) {
          if (key === "parentCustomer") {
            this.parentCustomer = customer[key];
          }
        }
      });
    },
    setupCustomerToEdit() {
      this.custCodeUpdateError = false;
      this.submitted = false;
      this.customer = { rebatePercent: null, msgDisplayMode: null, rebateMessage: null };
      this.region = {};
      this.branch = {};
      this.postCode = "";
      this.customerType = {};
      this.parentCustomer = {};
      this.tag = [];
      this.pendingTagNames = [];
      this.unresolvedTagNames = [];
      this.cityTown = {};
      this.parentFlag = false;

      this.duplicates = [];
      this.duplicateChecking = false;
      this.lastEnteredName = "";
      this.lastEnteredPostCode = "";
      this.lastEnteredAddress1 = "";
      this.lastEnteredAddress2 = "";
      this.lastEnteredAddress3 = "";
      this.lastEnteredCityTown = "";
      this.displayDuplicateMessage = false;

      if (this.customerToEdit && this.customerToEdit.customerId) {
        this.customerService
          .getCustomerInfo(this.customerToEdit.customerId)
          .then(data => {
            this.setupEditCustomer(data);
          })
          .catch(error => {
            this.$store.dispatch("addErrorMessage", {
              severity: "error",
              content:
                'Some data was not loaded from "customerInfo/{customerId}"'
            });

            this.setupEditCustomer(this.customerToEdit);
          });

        this.getCustomerContacts(this.customerToEdit.customerId);
      } else {
        this.customer.country = "UK";
      }
    },
    assignCustomer() {
      let permission = this.myPermissions.find(
        a => a.permission.permissionCode === "AssignCustomer"
      );
      if (permission) {
        if (permission.permissionLevel !== 0) {
          if (
            this.customerToEdit &&
            this.customerToEdit.customerId &&
            this.customerToEdit.requireApproval
          ) {
            this.$emit("customerForApproval", this.customerToEdit);
          }
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "You don't have permission to assign the customer",
            life: 5000
          });
        }
      }
    },
    sendCustomerRequest() {
      if (
        this.customerToEdit &&
        this.customerToEdit.customerId &&
        this.customerToEdit.requireApproval &&
        !(
          this.$store.getters["auth/getMyProfile"] &&
          this.$store.getters["auth/getMyProfile"].role &&
          this.$store.getters["auth/getMyProfile"].role.roleName &&
          this.$store.getters["auth/getMyProfile"].role.roleName === "Admin"
        )
      ) {
        customerLessDataRequest(this, "customerForm.vue");
      } else {
        customerRequest(this, "customerForm.vue");
      }
    },
    saveCustomer(approval) {
      this.submitted = true;
      this.sendingRequest = true;
      if (
        this.customerToEdit &&
        this.customerToEdit.customerId &&
        approval === false
      ) {
        this.customer.requireApproval = approval;
      } else {
        delete this.customer.requireApproval;
      }

      //

      if (
        !(
          this.customerToEdit &&
          this.customer.custCode === this.customerToEdit.custCode
        ) &&
        this.customer.mbpBranch
      ) {
        if (this.customer.custCode) {
          this.customerService
            .checkCustCode(this.customer.custCode, this.customer.mbpBranch.id)
            .then(data => {
              if (data.length) {
                this.duplicateCustCode = data;
                this.duplicateAccountNoWarning = true;
                this.sendingRequest = false;
              } else {
                this.sendCustomerRequest();
              }
            })
            .catch(err => {
              // this.$toast.add({
              //   severity: "error",
              //   summary: "Error",
              //   detail: "Error while geting customer code for duplicate",
              //   life: 5000,
              // })
              this.sendingRequest = false;
              this.$store.dispatch("addErrorMessage", {
                severity: "error",
                content:
                  'Some data was not loaded from "checkCustCode/{custCode}/{branchId}"'
              });
            });
        } else {
          this.sendCustomerRequest();
        }
      } else {
        this.sendCustomerRequest();
      }
    },
    getCustomerContacts(customerId) {
      this.customerService
        .getCustomerContacts(customerId)
        .then(data => (this.contacts = data))
        .catch(e => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting customer contacts",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content:
              'Some data was not loaded from "customerContacts/{customerId}"'
          });
        });
    },
    hideDialog() {
      this.$emit("close");
    },
    setParentSelection({ value, index }) {
      //
      this.parentCustomer = value;
    },
    setCityTownSelection({ value, index }) {
      //
      this.cityTown = value;
      this.checkForDuplicate();
    }
  }
};
</script>

<style></style>
